import { createAction } from 'redux-actions';
import * as Api from './api';

const receiveCustomFieldGroups = createAction('CUSTOM_FIELD_GROUPS_SUCCESS');
export const getCustomFieldGroups = payload => async dispatch => {
  const result = await Api.getCustomFieldGroups(payload);
  dispatch(receiveCustomFieldGroups(result));
  return result;
};
